/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (colonyID)
  {
    this.colonyID = colonyID;
  }


  matches (zone)
  {
    return zone.cass.colony === this.colonyID;
  }


  equals (other)
  {
    return other !== null && other.constructor === this.constructor && this.colonyID === other.colonyID;
  }


};
